// WalletPort — the ONLY interface a game uses to touch credits/money.
// Concrete adapters: WebWalletAdapter (online) and KioskWalletAdapter (cabinet).
// See ../../CONTRACTS.md §1. The game must never compute win/balance/RNG/RTP.

export class WalletPort {
  get mode() { return 'unknown'; }

  // eslint-disable-next-line class-methods-use-this
  async getConfig() {
    throw new Error('WalletPort.getConfig() not implemented');
  }

  // eslint-disable-next-line class-methods-use-this
  async placeSpin() {
    throw new Error('WalletPort.placeSpin() not implemented');
  }

  // eslint-disable-next-line class-methods-use-this
  async getBalance() {
    throw new Error('WalletPort.getBalance() not implemented');
  }

  // Machine-only; online adapters throw.
  // eslint-disable-next-line class-methods-use-this
  async creditIn() {
    throw new Error('WalletPort.creditIn() not available in this mode');
  }

  // eslint-disable-next-line class-methods-use-this
  async creditOut() {
    throw new Error('WalletPort.creditOut() not available in this mode');
  }
}
